/**
 * Logo Pannini 2026 — wordmark oficial Panini provisto + edition stamp "2026"
 * con gradient flame→gold→lime (mismo del sistema de la app).
 *
 * <Logo />        → wordmark + edition stamp
 * <Logo mark />   → solo sticker peelado (favicon/avatar)
 * <Logo size />   → altura en px
 */
type Props = { mark?: boolean; size?: number; className?: string };

export function Logo({ mark = false, size = 40, className = '' }: Props) {
  if (mark) {
    return (
      <svg
        viewBox="0 0 64 64"
        width={size}
        height={size}
        className={className}
        aria-label="Pannini 2026"
      >
        <defs>
          <linearGradient id="lg-holo" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%"   stopColor="#ff3d6b" />
            <stop offset="35%"  stopColor="#ffd166" />
            <stop offset="65%"  stopColor="#c6ff5e" />
            <stop offset="100%" stopColor="#5ee0ff" />
          </linearGradient>
          <linearGradient id="lg-card" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%"   stopColor="#1a0e2e" />
            <stop offset="100%" stopColor="#07050f" />
          </linearGradient>
        </defs>
        <rect x="0" y="0" width="64" height="64" rx="14" fill="url(#lg-holo)" />
        <path
          d="M 14 0 L 56 0 Q 64 0 64 8 L 64 44 Q 56 46 49 51 Q 44 56 41 64 L 8 64 Q 0 64 0 56 L 0 14 Q 0 0 14 0 Z"
          fill="url(#lg-card)"
          stroke="#231a3a"
          strokeWidth="1.5"
        />
        <text
          x="32" y="46" textAnchor="middle"
          fontFamily="Bricolage Grotesque, system-ui, sans-serif"
          fontWeight="800" fontSize="40" fill="#f4f1ff" letterSpacing="-2"
        >P</text>
        <path d="M 49 51 Q 53 47 64 44 L 64 54 Q 58 56 53 60 Z" fill="#ffffff" opacity="0.20" />
      </svg>
    );
  }

  const wordmarkHeight = size;
  return (
    <div
      className={`inline-flex items-center gap-3 ${className}`}
      style={{ height: wordmarkHeight }}
      aria-label="Pannini 2026"
    >
      <img
        src="/panini-official.svg"
        alt="Panini"
        style={{ height: wordmarkHeight, width: 'auto' }}
        draggable={false}
      />
      <EditionStamp height={wordmarkHeight} />
    </div>
  );
}

function EditionStamp({ height }: { height: number }) {
  const w = height * 1.8;
  return (
    <svg viewBox="0 0 90 50" width={w} height={height} style={{ display: 'block' }}>
      <defs>
        <linearGradient id="ed-grad" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%"   stopColor="#ff3d6b" />
          <stop offset="50%"  stopColor="#ffd166" />
          <stop offset="100%" stopColor="#c6ff5e" />
        </linearGradient>
      </defs>
      <rect
        x="2" y="6" width="86" height="38"
        rx="8"
        fill="none"
        stroke="url(#ed-grad)"
        strokeWidth="2"
        strokeDasharray="4 3"
      />
      <text
        x="45" y="32"
        textAnchor="middle"
        fontFamily="JetBrains Mono, ui-monospace, monospace"
        fontWeight="700"
        fontSize="20"
        fill="url(#ed-grad)"
        letterSpacing="3"
      >2026</text>
    </svg>
  );
}
